import React from 'react'

const FormLegend = (props) => {
  return (
    <legend>{props.label}</legend>
  )
}

export default FormLegend


// WEBPACK FOOTER //
// ./src/ui/FormLegend.js